/* ln-motion.js — Lilla Napoli scroll reveal (Fas 1)
   Fades + gently rises sections into view; staggers product cards
   within a row. Pairs with the .ln-reveal / .ln-in CSS in ln-figma.css.
   No-op under prefers-reduced-motion. Reversible: delete this file +
   its <script> in layout/theme.liquid. */
(function () {
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mq.matches) return; // respect reduced motion — show everything as-is

  function init() {
    var sections = document.querySelectorAll('#MainContent > .shopify-section');
    var targets = [];

    sections.forEach(function (sec, idx) {
      // Never fade the hero. idx 0 alone wasn't enough: an empty/zero-height
      // section can sit at index 0, pushing the real hero banner to index 1
      // where it WOULD get .ln-reveal — the eager LCP image paints, then the
      // fade replays it as a "blink/reload". Skip any banner (hero) section
      // outright. Fade only touches opacity+transform, so skipping adds no CLS.
      if (idx === 0 || sec.querySelector('.banner')) return;

      var cards = sec.querySelectorAll('.card-wrapper');
      if (cards.length > 1) {
        // Stagger the cards in this row (index resets per section, capped)
        cards.forEach(function (card, i) {
          card.classList.add('ln-reveal');
          card.style.setProperty('--ln-i', i % 6);
          targets.push(card);
        });
      } else {
        // Reveal the whole section as one block
        sec.classList.add('ln-reveal');
        targets.push(sec);
      }
    });

    if (!('IntersectionObserver' in window) || !targets.length) {
      // Fallback: no observer support → just show them
      targets.forEach(function (el) { el.classList.add('ln-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('ln-in');
          obs.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    targets.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
